/**
 * AISuggestionChips — Follow-up suggestion bubbles
 *
 * Inline bubble-width chips that fit the sentence length.
 * Shows a "Follow ups" header with actionable, contextual suggestions
 * generated by the AI based on the conversation.
 * Rendered inline below the AI message response.
 */

import React from 'react';
import { cn } from '../../utils/cn';

export default function AISuggestionChips({ suggestions = [], onSelect, disabled = false }) {
  if (!suggestions.length) return null;

  return (
    <div className="pt-1.5 pb-0.5" role="region" aria-label="Follow-up suggestions">
      <p className="text-[10px] font-medium text-gray-400 dark:text-gray-400 uppercase tracking-wider mb-1.5 px-0.5">
        Follow ups
      </p>
      <div className="flex flex-wrap gap-1.5">
        {suggestions.map((item, i) => {
          const label = typeof item === 'string' ? item : item?.prompt || item?.label;
          return (
            <button
              key={i}
              onClick={() => !disabled && onSelect(item)}
              disabled={disabled}
              className={cn(
                'inline-flex items-center gap-1.5 px-3 py-1.5 text-left text-[12px]',
                'rounded-full border border-gray-200/80 dark:border-gray-700/50',
                'bg-white dark:bg-gray-900/60',
                'text-gray-600 dark:text-gray-200',
                'hover:border-primary-300 dark:hover:border-primary-600',
                'hover:bg-primary-50/50 dark:hover:bg-primary-950/20',
                'hover:text-primary-700 dark:hover:text-primary-300',
                'transition-all duration-150',
                'disabled:opacity-40 disabled:cursor-not-allowed',
              )}
            >
              <span className="text-gray-400 dark:text-gray-400 flex-shrink-0 text-[12px] leading-none"
                aria-hidden="true"
              >
                &#x21B3;
              </span>
              <span className="leading-snug whitespace-nowrap">{label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
